/**
 * Recently Viewed Products — client-side, localStorage-backed.
 * Tracks PDP visits, renders a rail of the last 6 (excluding current product).
 */
(function () {
  var STORAGE_KEY = 'richard_recent_products';
  var MAX_STORED = 12;
  var MAX_SHOWN = 6;

  function readStore() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
    catch (_) { return []; }
  }

  function writeStore(arr) {
    if (!window.RichardConsent || !window.RichardConsent.has('functional')) return;
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(arr)); } catch (_) {}
  }

  // Track current product (PDP)
  var productEl = document.querySelector('[data-product-recent]');
  if (productEl) {
    var product = {
      id: productEl.dataset.productId,
      handle: productEl.dataset.productHandle,
      title: productEl.dataset.productTitle,
      image: productEl.dataset.productImage,
      price: productEl.dataset.productPrice,
      url: productEl.dataset.productUrl
    };
    if (product.id && product.handle) {
      var list = readStore();
      list = list.filter(function (p) { return p.id !== product.id; });
      list.unshift(product);
      if (list.length > MAX_STORED) list = list.slice(0, MAX_STORED);
      writeStore(list);
    }
  }

  // Render rail
  var rail = document.querySelector('[data-recently-viewed]');
  var track = document.querySelector('[data-recently-viewed-track]');
  if (!rail || !track) return;

  var current = productEl ? productEl.dataset.productId : null;
  var items = readStore().filter(function (p) { return p.id !== current; }).slice(0, MAX_SHOWN);
  if (items.length === 0) return;

  function esc(s) {
    if (s == null) return '';
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  var html = items.map(function (p) {
    var safeTitle = esc(p.title);
    var img = p.image
      ? '<img src="' + esc(p.image) + '" alt="' + safeTitle + '" loading="lazy">'
      : '';
    return '<a href="' + esc(p.url) + '" class="recently-viewed__card">' +
      '<div class="recently-viewed__media">' + img + '</div>' +
      '<p class="recently-viewed__title">' + safeTitle + '</p>' +
      (p.price ? '<p class="recently-viewed__price">' + esc(p.price) + '</p>' : '') +
    '</a>';
  }).join('');

  track.innerHTML = html;
  rail.hidden = false;
})();
